import { render, staticRenderFns } from "./ModernTableColumn.vue?vue&type=template&id=a1603c0a&"
import script from "./ModernTableColumn.vue?vue&type=script&lang=js&"
export * from "./ModernTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports